exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slider_arrow{text-align:center;font-size:32px!important;line-height:0;position:absolute;top:50%;display:block;width:20px;height:20px;padding:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;color:gray;border:none;outline:none;background:transparent}.slider_arrow__next{right:-28px}.slider_arrow__prev{left:-28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/shared/sliderarrows.scss
// module id = 1046
// module chunks = 0